import React, { useState } from 'react';

const formatVal = (val) => {
  if (val === null || val === undefined) return '';
  if (val === 0) return '0';
  const str = val.toLocaleString('en-IN');
  if (val < 0) return <span className="text-[#c53030]">{str}</span>;
  return str;
};

const TableRow = ({ row, isGlobalExpanded, businessUnit }) => {
  const [expanded, setExpanded] = useState(isGlobalExpanded);
  
  React.useEffect(() => {
    setExpanded(isGlobalExpanded);
  }, [isGlobalExpanded]);

  const hasChildren = row.children && row.children.length > 0;
  const showKps = businessUnit === 'All business units' || businessUnit === 'SE KPS';
  const showOp = businessUnit === 'All business units' || businessUnit === 'SE OP (Paid O&M)';
  const showWh = businessUnit === 'All business units' || businessUnit === 'SE WH';
  
  return (
    <>
      <tr className={`border-b border-slate-200 transition-colors ${hasChildren ? 'bg-[#f4f7fc] font-semibold text-[#1e293b]' : 'bg-white text-slate-700'}`}>
        <td className="p-3 text-[15px] flex items-center gap-2">
          {hasChildren ? (
            <button onClick={() => setExpanded(!expanded)} className="text-[#3b82f6] focus:outline-none w-4 flex justify-center">
              {expanded ? <span className="text-[10px] transform rotate-90">▶</span> : <span className="text-[10px]">▶</span>}
            </button>
          ) : (
            <span className="w-4"></span>
          )}
          {row.id}
        </td>
        <td className="p-3 text-[15px]">{row.description}</td>
        {showKps && <td className="p-3 text-[15px] text-right">{formatVal(row.kps)}</td>}
        {showOp && <td className="p-3 text-[15px] text-right">{formatVal(row.op)}</td>}
        {showWh && <td className="p-3 text-[15px] text-right">{formatVal(row.wh)}</td>}
        <td className="p-3 text-[15px] text-right">{formatVal(row.total)}</td>
      </tr>
      {expanded && hasChildren && row.children.map(child => (
        <tr key={child.id} className="border-b border-slate-100 bg-white hover:bg-slate-50 transition-colors text-slate-600">
          <td className="p-3 pl-10 text-[14px] text-slate-400">{child.id}</td>
          <td className="p-3 text-[15px]">{child.description}</td>
          {showKps && <td className="p-3 text-[15px] text-right">{formatVal(child.kps)}</td>}
          {showOp && <td className="p-3 text-[15px] text-right">{formatVal(child.op)}</td>}
          {showWh && <td className="p-3 text-[15px] text-right">{formatVal(child.wh)}</td>}
          <td className="p-3 text-[15px] text-right">{formatVal(child.total)}</td>
        </tr>
      ))}
    </>
  );
};

const PLTable = ({ data, grandTotal, isExpanded, businessUnit }) => {
  const showKps = businessUnit === 'All business units' || businessUnit === 'SE KPS';
  const showOp = businessUnit === 'All business units' || businessUnit === 'SE OP (Paid O&M)';
  const showWh = businessUnit === 'All business units' || businessUnit === 'SE WH';

  return (
    <div className="mt-8 bg-white rounded-xl shadow-[0_2px_10px_rgba(0,0,0,0.04)] border border-slate-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-[#f8fafc] border-b border-slate-200">
              <th className="p-3 text-[14px] font-bold text-slate-600 w-24 tracking-wide">Sr</th>
              <th className="p-3 text-[14px] font-bold text-slate-600 tracking-wide">Description</th>
              {showKps && <th className="p-3 text-[14px] font-bold text-slate-600 text-right tracking-wide">SE KPS</th>}
              {showOp && <th className="p-3 text-[14px] font-bold text-slate-600 text-right tracking-wide">SE OP (Paid O&M)</th>}
              {showWh && <th className="p-3 text-[14px] font-bold text-slate-600 text-right tracking-wide">SE WH</th>}
              <th className="p-3 text-[14px] font-bold text-slate-600 text-right tracking-wide">Grand Total</th>
            </tr>
          </thead>
          <tbody>
            {data.map(row => (
              <TableRow key={row.id} row={row} isGlobalExpanded={isExpanded} businessUnit={businessUnit} />
            ))}
            <tr className="bg-[#f4f7fc] font-bold border-t-2 border-slate-300 text-[#1e293b]">
              <td className="p-3 text-[15px]"></td>
              <td className="p-3 text-[15px]">Grand Total</td>
              {showKps && <td className="p-3 text-[15px] text-right">{formatVal(grandTotal.kps)}</td>}
              {showOp && <td className="p-3 text-[15px] text-right">{formatVal(grandTotal.op)}</td>}
              {showWh && <td className="p-3 text-[15px] text-right">{formatVal(grandTotal.wh)}</td>}
              <td className="p-3 text-[15px] text-right">{formatVal(grandTotal.total)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PLTable;
